module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 007.5a622bc0.jpg";